import { render, staticRenderFns } from "./AddEditEDocumentHeader.vue?vue&type=template&id=39c1ee12&scoped=true"
import script from "./AddEditEDocumentHeader.vue?vue&type=script&lang=js"
export * from "./AddEditEDocumentHeader.vue?vue&type=script&lang=js"
import style0 from "./AddEditEDocumentHeader.vue?vue&type=style&index=0&id=39c1ee12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1ee12",
  null
  
)

export default component.exports